import "./ErrorFallback.css";

export default function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <div className="error-container">
      <div className="error-content">
        <h1>😢 Oops!</h1>
        <h2>Something Went Wrong</h2>
        <p>We're sorry, but an unexpected error has occurred.</p>

        <div className="error-actions">
          <button onClick={resetErrorBoundary} className="retry-btn">
            🔄 Retry
          </button>
        </div>
      </div>
    </div>
  );
}
